import { throttle } from './Util.js';
import { makeRequest } from './LikeAndFavorite.js'


let storePromise;

function render(containerDom) {
    let $moreContainer = $(containerDom);
    const $tabContainer = $moreContainer.closest('.js-tab-content');
    const isTabContainer = $tabContainer.length > 0;
    let $moreContainerPage = isTabContainer ? $('.js-more-page', $tabContainer) : $('.js-more-page');
    let $moreButton = $moreContainer.siblings('.js-more-container-button');
    let loadByScroll = !$moreButton.length;
    let currScrollTop = 0;
    let finishPositionWrapper;

    App.W.on('resize', setActualPosition);

    setTimeout(setActualPosition, 500);

    App.W.on('load', function () {
        setTimeout(function () {
            setActualPosition();
        }, 1500);
    });

    if (isTabContainer) {
        $tabContainer.on('tabContentShow', setActualPosition);
    }

    if (loadByScroll) {
        App.W.on('scroll', () => {
            loadScrollCheckScroll();
        });
    }

    App.D.on('click', '.js-more-container-button', function (e) {
        e.preventDefault();
        let $moreContainer = $(this).siblings('.js-more-container');
        $moreContainer.addClass('_loading');
        if ($(this).attr('data-query')) {
            $moreContainer.data('query', $(this).attr('data-query'));
        }
        console.log('load by click: ', $(this));
        loadMore($moreContainer);
    });

    const loadScrollCheckScroll = throttle(() => {
        if (!isTabContainer || $tabContainer.hasClass('_active')) {
            currScrollTop = App.W.scrollTop();

            let userInVisibleScreen = $moreContainer.offset().top + $moreContainer.outerHeight() > currScrollTop - 300;

            //if (currScrollTop > finishPositionWrapper && !$moreContainer.hasClass('_loading') && userInVisibleScreen) {
            if (currScrollTop > finishPositionWrapper && !$moreContainer.hasClass('_loading') && userInVisibleScreen && !$moreContainer.hasClass('_no-more-load')) {
                $moreContainer.addClass('_loading');

                console.log('load by scroll');
                loadMore($moreContainer);
            }
        }
    }, 200);

    function getActualPosition() {
        return $moreContainer.offset().top + $moreContainer.innerHeight() - document.documentElement.clientHeight * (App.mobile ? 2 : 1.5);
        //return 0.8 * ($moreContainer.offset().top + $moreContainer.outerHeight());
    }

    function setActualPosition() {
        finishPositionWrapper = getActualPosition();
    }

    function loadMore(moreContainer) {
        let currPage = parseInt($moreContainerPage.val());
        let pageParamName = $moreContainerPage.attr('name') === undefined ? 'page' : $moreContainerPage.attr('name');
        let url = moreContainer.data('url');
        currPage++;

        /**  --убрать */
        /** для проверки прелоадера */
        /*setTimeout(function () {*/
        /**  --убрать */

        let loadData = `${pageParamName}=${currPage}`;
        if (moreContainer.parents('.js-pharmacies').length) {
            loadData = `search=${$('.js-pharmacies').find('.js-pharmacy-search-input').val()}&${pageParamName}=${currPage}`;
        }
        if (moreContainer.data('query')) {
            loadData = '';
            url = moreContainer.data('query');
        }

        moreContainer.trigger('loadMore:before');
        moreContainer.siblings('.js-more-container-button').addClass('_disabled');

        $.ajax({
            url: url,
            method: moreContainer.data('type'),
            //data: `page=${currPage}`,
            data: loadData,
            success: (response) => {
                let $response = $(response);
                $response.find('.js-store-product').each(function() {
                    $(this).attr('data-page', currPage);
                });

                let $btnQuery;
                if ($response.find('.js-more-container-button') && $response.find('.js-more-container-button').attr('data-query')) {
                    $btnQuery = $response.find('.js-more-container-button');
                }
                if ($(moreContainer.find('.js-likes-btn-detail')).length > 0){
                    $(moreContainer.find('.js-likes-btn-detail')).each(function (){
                        $(this).addClass('addSuccess')
                    })
                }

                moreContainer.append($response.html());

                if ($(moreContainer.find('.js-likes-btn-detail')).length > 0){
                    $(moreContainer.find('.js-likes-btn-detail')).each(function (){
                        if(!$(this).hasClass('addSuccess')){
                            $(this).on('click', function (e) {
                                e.preventDefault();
                                makeRequest($(this), 'like');
                            })
                        }
                    })
                }

                if ($btnQuery) {
                    moreContainer.closest('.js-pharmacies-list').find('.js-more-container-button').remove();
                    moreContainer.closest('.js-pharmacies-list').append($btnQuery);
                }
                moreContainer.trigger('loadMore', moreContainer);

                if ($(response).hasClass('_no-more-load')) {
                    moreContainer.addClass('_no-more-load');
                }

                setTimeout(function () {
                    if (loadByScroll) {
                        finishPositionWrapper = getActualPosition();
                    }
                    $moreContainerPage.val(currPage);
                    moreContainer.removeClass('_loading');
                }, 300);

                if (!storePromise && document.querySelector('.js-store-product, .js-slider-products-store, .js-products-wrapper, .js-pharmacies-list, .js-more-container-button')) {
                    storePromise = import('/_src/js/store/_store.js');
                }
                storePromise && storePromise.then(({productQuantity, productsSliderSync, userFavouriteProducts}) => {
                    productQuantity();
                    productsSliderSync();
                    userFavouriteProducts();
                });

                ///if (moreContainer.hasClass('js-catalog-with-pages')) {
                if (moreContainer.hasClass('js-catalog-with-pages') && !moreContainer.hasClass('_product-clicked')) {
                    let baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                    // let newUrl = baseUrl + '?' + loadData;
                    let newUrl;

                    if (window.location.href.indexOf('?') > 0) {
                        let params = new URLSearchParams(document.location.search);
                        let page = params.get('page');

                        if (page) {
                            params.set('page', currPage);
                            newUrl = baseUrl + '?' + params;
                        } else {
                            newUrl = baseUrl + '?' + params + '&' + loadData;
                        }
                    } else {
                        newUrl = baseUrl + '?' + loadData;
                    }

                    history.pushState(null, null, newUrl);
                }
            },
            error: () => {
                console.log('Ошибка получения данных фильтра');
                moreContainer.removeClass('_loading');
            },
            complete: () => {
                moreContainer.trigger('loadMore:complete');
                moreContainer.siblings('.js-more-container-button').removeClass('_disabled');
            }
        });

        /**  --убрать */
        /*}, 3000);*/
        /**  --убрать */
    }
}

$('.js-more-container').each((i, container) => {
    render(container);
});
